// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"30":"component---node-modules-shapeable-gatsby-theme-shapeable-src-components-app-tsx","227":"component---node-modules-shapeable-gatsby-theme-shapeable-src-pages-404-tsx"}[chunkId] + "-" + {"30":"6130df24e312c81583d1","227":"11f4d0f3504d37c11cac"}[chunkId] + ".js";
};